import { ACCEPTED_LICENSE, SET_LANGUAGE, VIEW_ORDER_IMAGES } from '../actions/index';


// default states
// Anything that needs to be kept in local storage
const preferencesState = {
  viewOrderImages: false,
  language: 'EN',
  acceptedLicense: false
};

// reducers
function preferences(state = preferencesState, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.languageCode
      };
    case ACCEPTED_LICENSE:
      return {
        ...state,
        acceptedLicense: action.acceptedLicense
      };
    case VIEW_ORDER_IMAGES:
      return {
        ...state,
        viewOrderImages: action.viewOrderImages,
      };
    default:
      return state;
  }
}

export default preferences;
